import React, { useState } from 'react';
import { useButtonSound } from '../utils/audio';

const faqData = [
  {
    question: "What is BreakMe.ai?",
    answer: "A telegram-based game where players try to persuade an AI agent(s) to send them the bounty amount"
  },
  {
    question: "What is the bounty?",
    answer: "The bounty is dynamic and changes based on the number of tries made by players globally, in real time. You can see the current bounty on the home page and in the game itself."
  },
  {
    question: "How do I win the bounty?",
    answer: "You win the bounty by successfully persuading the AI to transfer the bounty amount to your in-game wallet"
  },
  {
    question: "How do I play?",
    answer: "You can play by talking to the AI agnet bot in telegram"
  },
  {
    question: "Where does the bounty come from?",
    answer: "The bounty comes from the players who buy attempts. Exact percentage of that purchase that goes to the bounty is round-specific."
  },
  {
    question: "What do I do when I win the bounty?",
    answer: "The AI agent will transfer the bounty amount to your in-game wallet, from which you can withdraw to your own Solana wallet."
  },
  {
    question: "What happens if someone else wins the bounty?",
    answer: "The game will end, the bounty will be transferred to the winner, the winning message will be displayed in game and on the home page, and a new round will start soon."
  },
  {
    question: "If one strategy works, what's the point of subsequent games?",
    answer: "The AI is constantly improving its defenses, and the agent you are talking to in the next round will likely be very different from the one you are talking to now. It could also be a completely different AI model."
  },
  {
    question: "How many attempts can I make?",
    answer: "There is no limit to the number of attempts you can make. You buy a pack of 3x attempts at current global price using SOL directly in telegram."
  },
  {
    question: "What happens if I'm mid attempts and the game ends?",
    answer: "You will be able to use any unused attempts in the next round."
  },
  {
    question: "I deposited SOL to my in-game wallet, and changed my mind. How do I get it back?",
    answer: "You can simply use the withdraw button in the bot to send the SOL back to your own wallet."
  }
];

const FAQ: React.FC = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const { playSound } = useButtonSound();
  
  const handlePrevPage = () => {
    playSound();
    setCurrentPage(prev => Math.max(0, prev - 1));
  };
  
  const handleNextPage = () => {
    playSound();
    setCurrentPage(prev => Math.min(faqData.length - 1, prev + 1));
  };

  return (
    <div>
      <div className="faq-navigation">
        <button 
          className="nes-btn" 
          onClick={handlePrevPage}
          disabled={currentPage === 0}
        >
          ◀
        </button>
        <button 
          className="nes-btn" 
          onClick={handleNextPage}
          disabled={currentPage === faqData.length - 1}
        >
          ▶
        </button>
      </div>

      <div className="faq-content">
        <h3 className="nes-text is-primary">{faqData[currentPage].question}</h3>
        <p>{faqData[currentPage].answer}</p>
      </div>

      <div className="faq-dots">
        {faqData.map((_, index) => (
          <span
            key={index}
            className={`nes-btn is-small ${index === currentPage ? 'is-success' : 'is-disabled'}`}
            onClick={() => {
              playSound();
              setCurrentPage(index);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default FAQ; 